import { IAkustikkPremissRapport } from "../reportSchemas/akustikk/akustikkPremissrapportSchema";

export const AKUSTIKK_INIT_DATA: IAkustikkPremissRapport = {
  generellInfo: {
    oppdragsnavn: "",
    oppdragsgiver: "",
    emne: "",
    dokumentkode: "",
    kontaktperson: "",
    tilgjengelighet: "",
    oppdragsleder: "",
    utarbeidetAv: "",
    ansvarligEnhet: "",
    revisjon: "",
  },
  prosjektinfo: {
    fase: {
      skisseForprosjekt: {
        isActive: false,
        text: "Skisse/forprosjekt",
      },
      totalenterprisegrunnlag: {
        isActive: false,
        text: "Totalentreprisegrunnlag",
      },
      detaljprosjekt: {
        isActive: false,
        text: "Detaljprosjekt (PRO)",
      },
      rehabilitering: {
        isActive: false,
        text: "Skal hele eller deler av bygg rehabiliteres?",
      },
    },
    vedlegg: {
      lydtegninger: {
        isActive: true,
        text: "Lydtegninger som vedlegg",
      },
      tabellEllerTekst: {
        text: "Velg om grenseverdier skal vises i tabell eller vedlegg:",
        isActive: true,
        tabellGrenseverdier: {
          text: "Tabell med grenseverdier og tekniske løsninger",
          isActive: true,
        },
        henvisningVedlegg: {
          text: "Henvisning til vedlegg med grenseverdier og eksempelvegger/tekniske løsninger",
          isActive: false,
        },
      },
    },
    typeBygg: {
      bolig: {
        isActive: false,
        text: "Bolig",
        flerFamiliehus: {
          isActive: false,
          text: "Flerfamiliehus",
        },
      },
      undervisningsbygg: {
        isActive: false,
        text: "Undervisningsbygg",
      },
      barnehage: {
        isActive: false,
        text: "Barnehage",
      },
      helsebygg: {
        isActive: false,
        text: "Helsebygg",
      },
      omsorgsboliger: {
        isActive: false,
        text: "Omsorgsboliger",
      },
      hotell: {
        isActive: false,
        text: "Overnattingssted/hotell",
      },
      kontorbygg: {
        isActive: false,
        text: "Kontorbygg",
      },
      kulturbygg: {
        isActive: false,
        text: "Kulturbygg",
      },
      idrettsbygg: {
        isActive: false,
        text: "Idrettsbygg",
      },
      butikk: {
        isActive: false,
        text: "Butikk/næringsbygg",
      },
      produksjonsbygg: {
        isActive: false,
        text: "Produksjonsbygg/fabrikk",
      },
      restaurant: {
        isActive: false,
        text: "Restaurant",
      },
      treningsrom: {
        isActive: false,
        text: "Treningsrom",
      },
    },
    konstruksjonstype: {
      lette: {
        isActive: false,
        text: "Lette konstruksjoner",
      },
      tunge: {
        isActive: false,
        text: "Tunge konstruksjoner",
      },
      massivtre: {
        isActive: false,
        text: "Massivtre",
      },
      heis: {
        isActive: false,
        text: "Bygget har heis",
      },
    },
  },
  kapitler: [
    // 1
    {
      id: "kap1",
      title: "1: Informasjon om oppdraget og prosjektet",
      text: "1: Informasjon om oppdraget og prosjektet",
      isActive: true,
      children: [
        {
          id: "kap1_1",
          title: "1.1: Ansvar iht. Byggesaksforskriften",
          text: "1.1: Ansvar iht. Byggesaksforskriften",
          isActive: true,
        },
        {
          id: "kap1_2",
          title: "1.2: Ansvar andre aktører",
          text: "1.2: Ansvar andre aktører",
          isActive: true,
          children: [
            {
              id: "kap1_2_1",
              title: "Ha med tabell Grensesnitt og ansvarsforhold",
              text: "Ha med tabell Grensesnitt og ansvarsforhold",
              isActive: false,
            },
          ],
        },
      ],
    },

    // 2
    {
      id: "kap2",
      title: "2: Relevante krav",
      text: "2: Relevante krav",
      isActive: true,
      isDisabled: true,
      children: [
        {
          id: "kap2_1",
          title: "2.1: Myndighetskrav, standarder, andre prosjekteringskrav",
          text: "2.1: Myndighetskrav, standarder, andre prosjekteringskrav",
          isActive: false,
          children: [
            {
              id: "kap2_1_1",
              title: "NS 8175;2019 er gjeldende i prosjektet",
              text: "NS 8175;2019 er gjeldende i prosjektet",
              isActive: false,
            },
          ],
        },
        {
          id: "kap2_2",
          title: "2.2: Reguleringsbestemmelser",
          text: "2.2: Reguleringsbestemmelser",
          isActive: false,
        },
        {
          id: "kap2_3",
          title: "2.3: Bygge- og anleggsstøy",
          text: "2.3: Bygge- og anleggsstøy",
          isActive: true,
          children: [
            {
              id: "kap2_3_1",
              title: "Oslo kommune",
              text: "Oslo kommune",
              isActive: false,
            },
            {
              id: "kap2_3_2",
              title: "Bergen kommune",
              text: "Bergen kommune",
              isActive: false,
            },
            {
              id: "kap2_3_3",
              title: "Annen kommune",
              text: "Annen kommune",
              isActive: false,
            },
          ],
        },
        {
          id: "kap2_4",
          title: "2.4: TEK17",
          text: "2.4: TEK17",
          isActive: true,
          isDisabled: true,
          children: [
            {
              id: "kap2_4_1",
              title: "2.4.1: Generelt",
              text: "2.4.1: Generelt",
              isActive: true,
              isDisabled: true,
            },
            {
              id: "kap2_4_2",
              title: "2.4.2: Preaksepterte ytelser",
              text: "2.4.2: Preaksepterte ytelser",
              isActive: true,
              isDisabled: true,
            },
          ],
        },
        {
          id: "kap2_5",
          title: "2.5: BREEAM NOR – miljøytelsesstandard",
          text: "2.5: BREEAM NOR – miljøytelsesstandard",
          isActive: false,
          children: [
            {
              id: "kap2_5_1",
              title: "2.5.1: Vurderingskriterier Hea 05",
              text: "2.5.1: Vurderingskriterier Hea 05",
              isActive: false,
            },
            {
              id: "kap2_5_2",
              title: "2.5.2: Pol 05 Støydemping",
              text: "2.5.2: Pol 05 Støydemping",
              isActive: false,
            },
          ],
        },
        {
          id: "kap2_6",
          title: "2.6: Støy på arbeidsplassen (Tiltakshaver, leietaker)",
          text: "2.6: Støy på arbeidsplassen (Tiltakshaver, leietaker)",
          isActive: true,
          isDisabled: true,
        },
        {
          id: "kap2_7",
          title: "2.7: Prosjekteringsforutsetninger/Byggherre avklaringer",
          text: "2.7: Prosjekteringsforutsetninger/Byggherre avklaringer",
          isActive: false,
        },
        {
          id: "kap2_8",
          title: "2.8: Krav til prosjektering, kontroll av prosjektering og etterkontroll",
          text: "2.8: Krav til prosjektering, kontroll av prosjektering og etterkontroll",
          isActive: false,
          isDisabled: true,
        },
      ],
    },

    // 3
    {
      id: "kap3",
      title: "3: Underlag",
      text: "3: Underlag - Dette kapittelet omhandler underlag for akustiske beregninger/vurderinger.",
      isActive: true,
      isDisabled: true,
    },

    // 4
    {
      id: "kap4",
      title: "4: Utendørs støykilder (ARK, LARK, RIB, RIV, RIE)",
      text: "4: Utendørs støykilder (ARK, LARK, RIB, RIV, RIE)",
      isActive: false,
      children: [
        {
          id: "kap4_1",
          title: "4.1: Støy fra utendørs støykilde fly- og helikoptertrafikk",
          text: "4.1: Støy fra utendørs støykilde fly- og helikoptertrafikk",
          isActive: false,
          children: [
            { id: "kap4_1_1", title: "4.1.1: Lydnivå på fasader", text: "4.1.1: Lydnivå på fasader", isActive: false },
            {
              id: "kap4_1_2",
              title: "4.1.2: Lydnivå på uteoppholdsareal - felles",
              text: "4.1.2: Lydnivå på uteoppholdsareal - felles",
              isActive: false,
            },
            {
              id: "kap4_1_3",
              title: "4.1.3: Lydnivå på boligers private balkonger/terrasser",
              text: "4.1.3: Lydnivå på boligers private balkonger/terrasser",
              isActive: false,
            },
            {
              id: "kap4_1_4",
              title: "4.1.4: Materiale i støyskjermer",
              text: "4.1.4: Materiale i støyskjermer",
              isActive: false,
            },
          ],
        },
        {
          id: "kap4_2",
          title: "4.2: Støy fra utendørs støykilde vegtrafikk",
          text: "4.2: Støy fra utendørs støykilde vegtrafikk",
          isActive: false,
          children: [
            { id: "kap4_2_1", title: "4.2.1: Lydnivå på fasader", text: "4.2.1: Lydnivå på fasader", isActive: false },
            {
              id: "kap4_2_2",
              title: "4.2.2: Lydnivå på uteoppholdsareal - felles",
              text: "4.2.2: Lydnivå på uteoppholdsareal - felles",
              isActive: false,
            },
            {
              id: "kap4_2_3",
              title: "4.2.3: Lydnivå på boligers private balkonger/terrasser",
              text: "4.2.3: Lydnivå på boligers private balkonger/terrasser",
              isActive: false,
            },
            {
              id: "kap4_2_4",
              title: "4.2.4: Materiale i støyskjermer",
              text: "4.2.4: Materiale i støyskjermer",
              isActive: false,
            },
          ],
        },
        {
          id: "kap4_3",
          title: "4.3: Støy fra bane",
          text: "4.3: Støy fra bane",
          isActive: false,
          children: [
            { id: "kap4_3_1", title: "4.3.1: Lydnivå på fasader", text: "4.3.1: Lydnivå på fasader", isActive: false },
            {
              id: "kap4_3_2",
              title: "4.3.2: Lydnivå på uteoppholdsareal - felles",
              text: "4.3.2: Lydnivå på uteoppholdsareal - felles",
              isActive: false,
            },
            {
              id: "kap4_3_3",
              title: "4.3.3: Lydnivå på boligers private balkonger/terrasser",
              text: "4.3.3: Lydnivå på boligers private balkonger/terrasser",
              isActive: false,
            },
            {
              id: "kap4_3_4",
              title: "4.3.4: Materiale i støyskjermer",
              text: "4.3.4: Materiale i støyskjermer",
              isActive: false,
            },
          ],
        },
        {
          id: "kap4_4",
          title: "4.4: Støy fra havn og industri",
          text: "4.4: Støy fra havn og industri",
          isActive: false,
          children: [
            { id: "kap4_4_1", title: "4.4.1: Lydnivå på fasader", text: "4.4.1: Lydnivå på fasader", isActive: false },
            {
              id: "kap4_4_2",
              title: "4.4.2: Lydnivå på uteoppholdsareal - felles",
              text: "4.4.2: Lydnivå på uteoppholdsareal - felles",
              isActive: false,
            },
            {
              id: "kap4_4_3",
              title: "4.4.3: Lydnivå på boligers private balkonger/terrasser",
              text: "4.4.3: Lydnivå på boligers private balkonger/terrasser",
              isActive: false,
            },
            {
              id: "kap4_4_4",
              title: "4.4.4: Materiale i støyskjermer",
              text: "4.4.4: Materiale i støyskjermer",
              isActive: false,
            },
          ],
        },
        {
          id: "kap4_5",
          title:
            "4.5: Støy fra utendørs tekniske installasjoner til naboer og til egen fasade/eget uteareal (RIV, RIE, ENT)",
          text: "4.5: Støy fra utendørs tekniske installasjoner til naboer og til egen fasade/eget uteareal (RIV, RIE, ENT)",
          isActive: false,
        },
        {
          id: "kap4_6",
          title: "4.6: Støy til bolignaboer fra varelevering (ENT)",
          text: "4.6: Støy til bolignaboer fra varelevering (ENT)",
          isActive: false,
        },
        {
          id: "kap4_7",
          title: "4.7: Støy fra reservekraft-/nødstrømsaggregat (RIE/ENT)",
          text: "4.7: Støy fra reservekraft-/nødstrømsaggregat (RIE/ENT)",
          isActive: false,
        },
        {
          id: "kap4_8",
          title: "4.8: Støy fra nærmiljøanlegg (ENT,LARK)",
          text: "4.8: Støy fra nærmiljøanlegg (ENT,LARK)",
          isActive: false,
        },
      ],
    },

    // 5
    {
      id: "kap5",
      title: "5: Innendørs støykilder (ARK, RIB, RIV, RIE)",
      text: "5: Innendørs støykilder (ARK, RIB, RIV, RIE)",
      isActive: true,
      isDisabled: true,
      children: [
        {
          id: "kap5_1",
          title: "5.1: Boligventilasjon",
          text: "5.1: Boligventilasjon",
          isActive: false,
          isDisabled: true,
          children: [
            {
              id: "kap5_1_1",
              title: "5.1.1: Aggregat i boenhet",
              text: "5.1.1: Aggregat i boenhet",
              isActive: false,
              isDisabled: true,
            },
          ],
        },
        {
          id: "kap5_2",
          title: "5.2: Felles gatedør med dørpumpe (Flerfamiliehus)",
          text: "5.2: Felles gatedør med dørpumpe (Flerfamiliehus)",
          isActive: false,
          isDisabled: true,
        },
      ],
    },

    // 6
    {
      id: "kap6",
      title: "6: Prinsipper for lydisolasjon (ARK, RIB, RIV, RIE)",
      text: "6: Prinsipper for lydisolasjon (ARK, RIB, RIV, RIE)",
      isActive: true,
      isDisabled: true,
      children: [
        {
          id: "kap6_aktuelleLydkrav",
          title: "aktuelleLydkrav",
          text: "Aktuelle lydkrav",
          isActive: true,
          children: [
            { id: "kap6_rw24", title: "R'w 24 dB (m/dør)", text: "R'w 24 dB (m/dør)", isActive: false },
            { id: "kap6_rw30", title: "R'w 30 dB (m/dør-WC)", text: "R'w 30 dB (m/dør-WC)", isActive: false },
            { id: "kap6_rw3435", title: "R'w 34-35 dB (m/dør)", text: "R'w 34-35 dB (m/dør)", isActive: false },
            { id: "kap6_rw37", title: "R'w 37 dB", text: "R'w 37 dB", isActive: false },
            { id: "kap6_rw44", title: "R'w 44 dB", text: "R'w 44 dB", isActive: false },
            { id: "kap6_rw48", title: "R'w 48 dB", text: "R'w 48 dB", isActive: false },
            { id: "kap6_rw50", title: "R'w 50 dB (m/dør)", text: "R'w 50 dB (m/dør)", isActive: false },
            { id: "kap6_rw52", title: "R'w 52 dB", text: "R'w 52 dB", isActive: false },
            { id: "kap6_rw55", title: "R'w 55 dB med/uten dør", text: "R'w 55 dB med/uten dør", isActive: false },
            { id: "kap6_rw60", title: "R'w 60 dB", text: "R'w 60 dB", isActive: false },
            { id: "kap6_rw70", title: "R'w 70 dB", text: "R'w 70 dB", isActive: false },
          ],
        },
        {
          id: "kap6_tabellOverhoring",
          title: "Ta med tabell med forventet overhøring mht. skilleveggers lydisolasjon",
          text: "Ta med tabell med forventet overhøring mht. skilleveggers lydisolasjon",
          isActive: false,
        },

        {
          id: "kap6_1",
          title: "6.1: Hovedkonstruksjoner: Bærende konstruksjoner, tak og fasader",
          text: "6.1: Hovedkonstruksjoner: Bærende konstruksjoner, tak og fasader",
          isActive: true,
          isDisabled: true,
        },
        { id: "kap6_2", title: "6.2: Gulv på grunn", text: "6.2: Gulv på grunn", isActive: true },

        {
          id: "kap6_3",
          title: "6.3: Etasjeskillere",
          text: "6.3: Etasjeskillere",
          isActive: true,
          children: [
            {
              id: "kap6_3_1",
              title: "6.3.1: Betong/tunge dekker",
              text: "6.3.1: Betong/tunge dekker",
              isActive: false,
            },
            {
              id: "kap6_3_2",
              title: "6.3.2: Flytende, tunge gulv",
              text: "6.3.2: Flytende, tunge gulv",
              isActive: false,
            },
            { id: "kap6_3_3", title: "6.3.3: Massivtre", text: "6.3.3: Massivtre", isActive: false },
            { id: "kap6_3_4", title: "6.3.4: Trebjelkelag", text: "6.3.4: Trebjelkelag", isActive: false },
          ],
        },

        { id: "kap6_4", title: "6.4: Takterrasser", text: "6.4: Takterrasser", isActive: false },
        { id: "kap6_5", title: "6.5: Trapp", text: "6.5: Trapp", isActive: false },
        { id: "kap6_6", title: "6.6: Mesanin", text: "6.6: Mesanin", isActive: false },
        {
          id: "kap6_7",
          title: "6.7: Fasader/yttervegger (utendørs støykilder)",
          text: "6.7: Fasader/yttervegger (utendørs støykilder)",
          isActive: false,
          isDisabled: true,
        },
        {
          id: "kap6_8",
          title: "6.8: Tak (samferdselsstøy - flystøy)",
          text: "6.8: Tak (samferdselsstøy - flystøy)",
          isActive: false,
          isDisabled: true,
        },

        {
          id: "kap6_9",
          title: "6.9: Innvendige vegger",
          text: "6.9: Innvendige vegger",
          isActive: true,
          isDisabled: true,
          children: [
            {
              id: "kap6_9_1",
              title: "6.9.1: Skrufast platelag i platekledde vegger",
              text: "6.9.1: Skrufast platelag i platekledde vegger",
              isActive: true,
              isDisabled: true,
            },
            {
              id: "kap6_9_2",
              title: "6.9.2: Generelle krav til platekledde vegger med lydkrav",
              text: "6.9.2: Generelle krav til platekledde vegger med lydkrav",
              isActive: true,
              isDisabled: true,
            },
            {
              id: "kap6_9_3",
              title: "6.9.3: Tilslutningsdetaljer",
              text: "6.9.3: Tilslutningsdetaljer",
              isActive: true,
              isDisabled: true,
              children: [
                { id: "kap6_9_3_1", title: "Fasadeprofil", text: "Fasadeprofil", isActive: false },
                { id: "kap6_9_3_2", title: "Sandwich-element", text: "Sandwich-element", isActive: false },
                {
                  id: "kap6_9_3_3",
                  title: "Gulv på grunn (tynn bunnplate)",
                  text: "Gulv på grunn (tynn bunnplate)",
                  isActive: false,
                },
                {
                  id: "kap6_9_3_4",
                  title: "Tak (f.eks v/lett takkonstruksjon)",
                  text: "Tak (f.eks v/lett takkonstruksjon)",
                  isActive: false,
                },
              ],
            },
            {
              id: "kap6_9_4",
              title: "6.9.4: Vegger med dører og/eller glassfelt",
              text: "6.9.4: Vegger med dører og/eller glassfelt",
              isActive: true,
              isDisabled: true,
            },
            {
              id: "kap6_9_5",
              title: "6.9.5: Sandwichvegger mellom rom og verksteder",
              text: "6.9.5: Sandwichvegger mellom rom og verksteder",
              isActive: false,
            },
          ],
        },

        { id: "kap6_10", title: "6.10: Dører", text: "6.10: Dører", isActive: true, isDisabled: true },
        {
          id: "kap6_11",
          title: "6.11: Fleksible himlingsløsninger/Gjennomgående himlinger i kontorer",
          text: "6.11: Fleksible himlingsløsninger/Gjennomgående himlinger i kontorer",
          isActive: false,
        },

        {
          id: "kap6_12",
          title: '6.12: "Rom-i-rom". Prinsipper for rom med lydkrav R’w ≥ 60/70 dB',
          text: '6.12: "Rom-i-rom". Prinsipper for rom med lydkrav R’w ≥ 60/70 dB',
          isActive: false,
          children: [
            {
              id: "kap6_12_1",
              title: "6.12.1: Dobbel vindus-/dørkonstruksjon",
              text: "6.12.1: Dobbel vindus-/dørkonstruksjon",
              isActive: false,
            },
          ],
        },

        { id: "kap6_13", title: "6.13: Folde-/modulvegger", text: "6.13: Folde-/modulvegger", isActive: false },
        {
          id: "kap6_14",
          title: "6.14: Prefabrikkerte baderomskabiner",
          text: "6.14: Prefabrikkerte baderomskabiner",
          isActive: false,
        },
        { id: "kap6_15", title: "6.15: Skillevegg mot heis", text: "6.15: Skillevegg mot heis", isActive: false },
        {
          id: "kap6_16",
          title: "6.16: Innkassing av avløpsrør",
          text: "6.16: Innkassing av avløpsrør",
          isActive: true,
          isDisabled: true,
        },

        {
          id: "kap6_17",
          title: "6.17: Sjakter",
          text: "6.17: Sjakter",
          isActive: true,
          isDisabled: true,
          children: [
            {
              id: "kap6_17_1",
              title: "6.17.1: Sjakter for tøy og avfall (helsebygg)",
              text: "6.17.1: Sjakter for tøy og avfall (helsebygg)",
              isActive: false,
            },
            { id: "kap6_17_2", title: "6.17.2: Luker til sjakter", text: "6.17.2: Luker til sjakter", isActive: false },
          ],
        },

        {
          id: "kap6_18",
          title: "6.18: Tekniske skap i vegger",
          text: "6.18: Tekniske skap i vegger",
          isActive: true,
          isDisabled: true,
        },

        {
          id: "kap6_19",
          title: "6.19: Vegger rundt rom med støyende utstyr og/eller støyende aktiviteter",
          text: "6.19: Vegger rundt rom med støyende utstyr og/eller støyende aktiviteter",
          isActive: true,
          isDisabled: true,
          children: [
            { id: "kap6_19_1", title: "6.19.1: Tekniske rom", text: "6.19.1: Tekniske rom", isActive: false },
            {
              id: "kap6_19_2",
              title: "6.19.2: Rom med støyende utstyr og/eller støyende aktiviteter",
              text: "6.19.2: Rom med støyende utstyr og/eller støyende aktiviteter",
              isActive: false,
            },
            {
              id: "kap6_19_3",
              title: "6.19.3: Lydisolerte vegger rundt bod med ventilasjonsaggregat",
              text: "6.19.3: Lydisolerte vegger rundt bod med ventilasjonsaggregat",
              isActive: false,
            },
            { id: "kap6_19_4", title: "6.19.4: Vegger rundt WC", text: "6.19.4: Vegger rundt WC", isActive: false },
            {
              id: "kap6_19_5",
              title: "6.19.5: Plassering av stasjonært AV-utstyr i naborom",
              text: "6.19.5: Plassering av stasjonært AV-utstyr i naborom",
              isActive: false,
            },
          ],
        },
      ],
    },

    // 7
    {
      id: "kap7",
      title: "7: Prinsipper for romakustikk (ARK, IARK, RIB, RIV, RIE)",
      text: "7: Prinsipper for romakustikk (ARK, IARK, RIB, RIV, RIE)",
      isActive: true,
      isDisabled: true,
      children: [
        {
          id: "kap7_1",
          title: "7.1: Lydabsorbenter - eksempler",
          text: "7.1: Lydabsorbenter - eksempler",
          isActive: true,
        },
        {
          id: "kap7_2",
          title: "7.2: Akustisk regulering av rom",
          text: "7.2: Akustisk regulering av rom",
          isActive: true,
          isDisabled: true,
        },
        {
          id: "kap7_3",
          title: "7.3: Plassering av stasjonært AV-utstyr, tavler o.l. med hensyn til lydabsorbenter på veggflater",
          text: "7.3: Plassering av stasjonært AV-utstyr, tavler o.l. med hensyn til lydabsorbenter på veggflater",
          isActive: false,
          isDisabled: true,
        },
      ],
    },

    // 8
    {
      id: "kap8",
      title: "8: Prinsipper bygningstekniske installasjoner (RIV, RIE, ARK, IARK)",
      text: "8: Prinsipper bygningstekniske installasjoner (RIV, RIE, ARK, IARK)",
      isActive: true,
      isDisabled: true,
      children: [
        {
          id: "kap8_1",
          title: "8.1: VVS-teknisk utstyr og føringer (RIV, IARK, ARK)",
          text: "8.1: VVS-teknisk utstyr og føringer (RIV, IARK, ARK)",
          isActive: true,
          isDisabled: true,
          children: [
            {
              id: "kap8_1_1",
              title: "8.1.1: Ventilasjonsanlegg",
              text: "8.1.1: Ventilasjonsanlegg",
              isActive: true,
              isDisabled: true,
            },
            {
              id: "kap8_1_2",
              title: "8.1.2: Vann-, varme- og sanitæranlegg",
              text: "8.1.2: Vann-, varme- og sanitæranlegg",
              isActive: true,
              isDisabled: true,
            },
          ],
        },
        {
          id: "kap8_2",
          title: "8.2: Elektroteknisk utstyr og føringer (RIE, IARK, ARK)",
          text: "8.2: Elektroteknisk utstyr og føringer (RIE, IARK, ARK)",
          isActive: true,
          isDisabled: true,
          children: [
            {
              id: "kap8_2_1",
              title: "8.2.1: El-kanaler og -skinner",
              text: "8.2.1: El-kanaler og -skinner",
              isActive: true,
            },
            {
              id: "kap8_2_2",
              title: "8.2.2: El-bokser innfelt i vegg",
              text: "8.2.2: El-bokser innfelt i vegg",
              isActive: true,
              isDisabled: true,
            },
            {
              id: "kap8_2_3",
              title: "8.2.3: Kabelføringer",
              text: "8.2.3: Kabelføringer",
              isActive: true,
              isDisabled: true,
            },
          ],
        },
        {
          id: "kap8_3",
          title: "8.3: Heis",
          text: "8.3: Heis",
          isActive: false,
          isDisabled: true,
        },
        {
          id: "kap8_4",
          title: "8.4: Perforering av gjennomgående himlinger med downlights o.l.",
          text: "8.4: Perforering av gjennomgående himlinger med downlights o.l.",
          isActive: true,
          isDisabled: true,
        },
      ],
    },

    // 9
    {
      id: "kap9",
      title: "9: Lyd- og taleoverføringsutstyr (RIE, RIBR, Tiltakshaver, brukere)",
      text: "9: Lyd- og taleoverføringsutstyr (RIE, RIBR, Tiltakshaver, brukere)",
      isActive: false,
      isDisabled: true,
    },

    // 10
    {
      id: "kap10",
      title: "10: Vibrasjonsforhold (RIB, RIV, RIE)",
      text: "10: Vibrasjonsforhold (RIB, RIV, RIE)",
      isActive: true,
      isDisabled: true,
      children: [
        {
          id: "kap10_1",
          title: "10.1: Etasjeskillere i betong",
          text: "10.1: Etasjeskillere i betong",
          isActive: false,
        },
        {
          id: "kap10_2",
          title: "10.2: Etasjeskillere - gitterdragere i tre/massivtre",
          text: "10.2: Etasjeskillere - gitterdragere i tre/massivtre",
          isActive: false,
        },
        {
          id: "kap10_3",
          title: "10.3: Strukturlyd",
          text: "10.3: Strukturlyd",
          isActive: true,
          isDisabled: true,
          children: [
            {
              id: "kap10_3_1",
              title: "10.3.1: Interne kilder for strukturlyd",
              text: "10.3.1: Interne kilder for strukturlyd",
              isActive: true,
              isDisabled: true,
            },
            {
              id: "kap10_3_2",
              title: "10.3.2: Rør og kanaler - isolering mot strukturlyd",
              text: "10.3.2: Rør og kanaler - isolering mot strukturlyd",
              isActive: true,
              isDisabled: true,
            },
            {
              id: "kap10_3_3",
              title: "10.3.3: Balansert ventilasjon, individuelle anlegg",
              text: "10.3.3: Balansert ventilasjon, individuelle anlegg",
              isActive: false,
              isDisabled: true,
            },
            {
              id: "kap10_3_4",
              title: "10.3.4: Vann- og avløpsrør - isolering mot strukturlyd",
              text: "10.3.4: Vann- og avløpsrør - isolering mot strukturlyd",
              isActive: true,
              isDisabled: true,
            },
            { id: "kap10_3_5", title: "10.3.5: Heis", text: "10.3.5: Heis", isActive: false, isDisabled: true },
          ],
        },
      ],
    },

    // 11
    {
      id: "kap11",
      title: "11: Byggherreforskriften. HMS risikovurdering støy.",
      text: "11: Byggherreforskriften. HMS risikovurdering støy.",
      isActive: true,
      isDisabled: true,
    },

    // 12
    {
      id: "kap12",
      title: "12: Referanser",
      text: "12: Referanser",
      isActive: true,
      isDisabled: true,
    },

    // Vedlegg
    {
      id: "vedlegg",
      title: "Vedlegg",
      text: "Vedlegg",
      isActive: true,
      isDisabled: true,
      children: [
        {
          id: "vedleggA",
          title: "Vedlegg A: Lydkrav. TEK17 Lyd og vibrasjoner",
          text: "Vedlegg A: Lydkrav. TEK17 Lyd og vibrasjoner",
          isActive: false,
          isDisabled: true,
        },
        {
          id: "vedleggB",
          title: "Vedlegg B: T-1442. Anbefalte grenser for bygge- og anleggsstøy.",
          text: "Vedlegg B: T-1442. Anbefalte grenser for bygge- og anleggsstøy.",
          isActive: true,
          isDisabled: true,
        },
        {
          id: "vedleggC",
          title: "Vedlegg C: Akustiske definisjoner",
          text: "Vedlegg C: Akustiske definisjoner",
          isActive: true,
          children: [
            {
              id: "vedleggC_1",
              title: "Enkel liste med definisjoner",
              text: "Enkel liste med definisjoner",
              isActive: true,
            },
            {
              id: "vedleggC_2",
              title: "Tabell med definisjoner for tilpasning oppdrag",
              text: "Tabell med definisjoner for tilpasning oppdrag",
              isActive: false,
            },
          ],
        },
        {
          id: "vedleggD",
          title: "Vedlegg D: Lette skillekonstruksjoner med forventet luftlydisolasjon, R’w",
          text: "Vedlegg D: Lette skillekonstruksjoner med forventet luftlydisolasjon, R’w",
          isActive: false,
        },
        {
          id: "vedleggE",
          title: "Vedlegg E: Lydtegninger - Krav til luftlydisolasjon horisontalt",
          text: "Vedlegg E: Lydtegninger - Krav til luftlydisolasjon horisontalt",
          isActive: true,
          isDisabled: true,
        },
        {
          id: "vedleggF",
          title: "Vedlegg F: Støy på arbeidsplassen",
          text: "Vedlegg F: Støy på arbeidsplassen",
          isActive: false,
        },
      ],
    },
  ],
};
